import OpenTimeSearch from './OpenTimeSearch';

export default OpenTimeSearch;
